<template>
    <span class="rich-text">
        <template v-for="(segment, index) in segments" :key="index">
            <span v-if="segment.featured" class="rich-text-featured">{{ segment.text }}</span>
            <span v-else>{{ segment.text }}</span>
        </template>
    </span>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { parseRichText, RichTextSegment } from "@/utils/richTextFormatting";

export default defineComponent({
    name: "RichText",
    props: {
        text: {
            type: String,
            required: true,
        },
    },
    computed: {
        segments(): RichTextSegment[] {
            return parseRichText(this.text);
        },
    },
});
</script>

<style scoped>
.rich-text {
    display: inline;
}

.modal-action-container .rich-text-featured {
    font-weight: 800;
}
</style>
